
import { Image } from "react-bootstrap";
import styles from "./avatar.module.scss";

export const Avatar = ({
  user,
}: {
  user: {
    firstName?: string;
    email?: string;
    icon?: { thumbnail?: string } | null;
  };
}) => {
  const initial = (
    user.firstName?.charAt(0) ??
    user.email?.charAt(0) ??
    "?"
  ).toUpperCase();

  if (user.icon?.thumbnail) {
    return (
      <Image
        className={styles.contactIcon}
        src={user.icon.thumbnail}
        roundedCircle
      />
    );
  }

  return <div className={styles.avatar}>{initial}</div>;
};